const headerInstances = new WeakMap();
const countdownInstances = new WeakMap();

function initialiseHeader(header) {
  if (headerInstances.has(header)) return;
  const button = header.querySelector('[data-mmd-menu-toggle]');
  const menu = header.querySelector('.mmd-mobile-nav');
  if (!button || !menu) return;
  const controller = new AbortController();
  const { signal } = controller;
  const mobile = matchMedia('(max-width: 999px)');
  function closeMenu(focus = false) {
    menu.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Open menu');
    if (focus) button.focus();
  }
  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    menu.hidden = expanded;
    button.setAttribute('aria-expanded', String(!expanded));
    button.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
  }, { signal });
  menu.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); }, { signal });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !menu.hidden) closeMenu(true); }, { signal });
  document.addEventListener('click', event => { if (!header.contains(event.target)) closeMenu(); }, { signal });
  mobile.addEventListener('change', () => { if (!mobile.matches) closeMenu(); }, { signal });
  headerInstances.set(header, () => { closeMenu(); controller.abort(); headerInstances.delete(header); });
}

function initialiseCountdown(countdown) {
  if (countdownInstances.has(countdown)) return;
  const deadline = Date.parse(countdown.dataset.deadline);
  const days = countdown.querySelector('[data-mmd-days]');
  const hours = countdown.querySelector('[data-mmd-hours]');
  const minutes = countdown.querySelector('[data-mmd-minutes]');
  const label = countdown.querySelector('[data-mmd-deadline-label]');
  const controller = new AbortController();
  let timer;
  if (!Number.isFinite(deadline) || !days || !hours || !minutes) {
    countdown.hidden = true;
  } else {
    function updateTime() {
      const remaining = Math.max(0, deadline - Date.now());
      const totalMinutes = Math.ceil(remaining / 60000);
      days.textContent = String(Math.floor(totalMinutes / 1440));
      hours.textContent = String(Math.floor(totalMinutes / 60) % 24).padStart(2, '0');
      minutes.textContent = String(totalMinutes % 60).padStart(2, '0');
      if (!remaining && label) label.textContent = 'EARLY BIRD HAS ENDED';
      if (remaining) timer = setTimeout(updateTime, 30000);
    }
    updateTime();
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) { clearTimeout(timer); updateTime(); }
    }, { signal: controller.signal });
  }
  countdownInstances.set(countdown, () => { controller.abort(); clearTimeout(timer); countdownInstances.delete(countdown); });
}

function nodes(context, selector) {
  return [...(context.matches?.(selector) ? [context] : []), ...context.querySelectorAll(selector)];
}
function initialise(context) {
  nodes(context, '[data-mmd-header]').forEach(initialiseHeader);
  nodes(context, '[data-mmd-countdown]').forEach(initialiseCountdown);
}
initialise(document);
document.addEventListener('shopify:section:load', event => initialise(event.target));
document.addEventListener('shopify:section:unload', event => {
  nodes(event.target, '[data-mmd-header]').forEach(header => headerInstances.get(header)?.());
  nodes(event.target, '[data-mmd-countdown]').forEach(countdown => countdownInstances.get(countdown)?.());
});
